/** @format */

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import * as React from "react";
import ApplicantAudits from "../ApplicantAudits";
import MeansTestCalculation from "../MeansTestCalculation";
import SetStatus from "../SetStatus";
import ViewDocuments from "../ViewDocuments";
import ViewInstitutionDetails from "../ViewInstitutionDetails";
import ViewLeagalGuardians from "../ViewLeagalGuardians";
import ViewPersonalDetails from "../ViewPersonalDetails";
import AssessmentModal from "../Assessments/AssessmentModal";
import { AllApplicantDto } from "../../../applicant/Models";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { APPLICATION_STAGE } from "../../../../common/models/enums/applicationStage";
import { BackendApplicationStage } from "../../../../common/dropdowns/ApplicationStatus";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      
      {...other}
    >
      {value === index && (
        <Box sx={{ pl: 3, pr:3}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

interface Props {
  currentApplicationStatus: BackendApplicationStage;
  setFilterd: React.Dispatch<React.SetStateAction<APPLICATION_STAGE>>;
  applicantName: string;
  applicationId: number;
  tabValue: number;
  application?: AllApplicantDto;
}
export default function ViewApplication({
  currentApplicationStatus,
  setFilterd,
  applicantName,
  applicationId,
  tabValue,
  application,
}: Props) {
  return (
    <>
      <CustomTabPanel value={tabValue} index={0}>
        <ViewPersonalDetails />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <ViewInstitutionDetails />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <ViewLeagalGuardians />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={3}>
        <ViewDocuments />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={4}>
        <ApplicantAudits />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={5}>
        <AssessmentModal
          applicationId={applicationId}
          application={application}
        />
      </CustomTabPanel>

      <Box p={2}>
      <Accordion sx={{ mt: 3, border: "1px solid rgba(190, 190, 190, 0.59)" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="h5" variant="body2">
            Update Application Status
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SetStatus
            applicationId={applicationId}
            currentApplicationStatus={currentApplicationStatus}
            setFilterd={setFilterd}
            applicantName={applicantName}
          />
        </AccordionDetails>
      </Accordion>
      </Box>
    </>
  );
}
